import $http from '../http'
import { baseUrl } from '../url'
const BASEURL = baseUrl.primary + '/V1/JobApplication'

const JobApplicationInfo = {
  PageData(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/PageData`,
      data
    })
  },
  List(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/List`,
      data
    })
  },
  Create(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/Create`,
      data
    })
  },
   Apply(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/Apply`,
      data
    })
  },
   SetStatus(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/SetStatus`,
      data
    })
  },
  Detail(params) {
    return $http({
      method: 'get',
      url: `${BASEURL}`,
      params
    })
  },
  Modify(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/Modify`,
      data
    })
  },
  Delete(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/Delete`,
      data
    })
  }
}

export default JobApplicationInfo
